
export const technologies = [
    "HTML",
    "CSS",
    "JavaScript",
    "React",
    "Next.js",
    "Vue.js",
    "TailwindCSS",
    "Styled-Components",
    "Node.js",
    "Nest.js",
    "Express",
    "MongoDB",
    "GitHub",
    "TypeScript",
    "WordPress",
    "SQL",
    "React Native",
    "C#",
    ".NET",
    "Razor"
]